<template>
<div class="u-pos-relative">
    <v-loading :data="loaded"></v-loading>
    <!-- FILTERS-->
    <v-filters v-if="FilterData && dataFilter" custom-class="o-page-row--medium" :theme="filterTheme">
        <v-filter-checkbox
                v-for="(value, key, index) in FilterData"
                :key="value.Value"
                v-model="selectedFilters[filters[index].value]"
                :items="value"
                :filter-name="filters[index].name"
                :width="filters[index].width"
                @change="fetchData"
                item-name="DisplayValue"
                item-value="Value"
                :allowMultiple="filters[index].allowMultiple">
        </v-filter-checkbox>
        <v-input v-model="search"
               placeholder="Search"
               v-if="searchFilter"
               @input="fetchData"
               custom-class="u-inline-block"
               :debounce-delay="800"
               name="search"
               width="290px">
        </v-input>
        <slot name="placeholderButtons"></slot>
    </v-filters>

    <div :class="{'o-wrapper o-wrapper--center': wrapper}">

        <h3 v-if="title" class="c-title--border">{{ title }}</h3>

        <!-- PAGINATION-->
        <v-pagination v-if="dataPagination" class="c-pager o-page-row" :config="paginationConfig" :pagination="Pagination" @paginated="fetchData"></v-pagination>

        <!-- DATA TABLE -->
        <div class="c-table-wrapper">
            <div v-if="rowSelectable" class="select-all">
              <input name="row-selected" type="checkbox" id="select-all" v-model="allSelected" />
              <label v-if="allSelected" for="select-all">{{$t('global.remove_selection')}}</label>
              <label v-else for="select-all">{{$t('global.select_all')}}</label>
            </div>
            <table-component class="o-page-row" :table-class="`c-table c-table--small c-table--${dataTable}`" :data="table.rows" :show-caption="false" :show-filter="false">

                <table-column v-if="rowSelectable" cell-class="u-text-nowrap" label="" :sortable="false" :filterable="false">
                  <template slot-scope="row">
                    <div v-if="row.Id" class="o-spacing-tiny">
                      <input @change="$emit('selectedRows', rowSelected)" name="row-selected" type="checkbox" :id="'check_'+row.Id" :value="row.Id" v-model="rowSelected" />
                    </div>
                  </template>
                </table-column>

                <table-column v-for="column in tableColumns" :key="column.value" :show="column.value" :label="column.name" :sortable=false>
                        <template slot-scope="row">
                            <!-- TOOLTIP -->
                            <template v-if="column.type === 'Tooltip'">
                                <span v-tooltip="{
                                        content: row[column.value],
                                        classes: 'information'
                                      }">
                                    <svgicon name="info" width="1em" height="1em" class="u-svg-color-info-base"></svgicon>
                                </span>
                            </template>
                            <!-- DATE -->
                            <template v-else-if="column.type === 'Date'">
                                {{ row[column.value] | moment("DD-MM-YYYY") }}
                            </template>
                            <!-- RADIO -->
                            <template v-else-if="column.type === 'Boolean'">
                                <span v-if="row[column.value]">{{ $t('global.yes') }}</span>
                                <span v-else="">{{ $t('global.no') }}</span>
                            </template>
                            <!-- MESSAGE -->
                            <template v-else-if="column.type === 'Message'">
                                <div v-if="row[column.value]" class="u-margin-left-small">
                                    <img src="@/assets/images/icons/message_active.png" alt="message icon" />
                                </div>
                                <div v-else class="u-margin-left-small">
                                    <img src="@/assets/images/icons/message.png" alt="message icon" />
                                </div>
                            </template>
                            <!-- COLOR -->
                            <template v-else-if="column.type === 'Color'">
                              <div v-if="row[column.value]" class="c-product-color-element" v-bind:style="{ backgroundColor: row[column.value] }"></div>
                            </template>
                            <!-- IMAGE -->
                            <template v-else-if="column.type === 'Image'">
                              <img v-if="row[column.value]" :src="row[column.value].replace('[WIDTH]','60').replace('[HEIGHT]','60')" alt="" />
                              <img v-else width="60px" src="@/assets/images/no_image.png" alt="">
                            </template>
                            <!-- CURRENCY -->
                            <template v-else-if="column.type === 'Currency'">
                                <span v-if="row[column.value]">{{ row[column.value] | currency(customerCurrencySymbol) }}</span>
                            </template>
                            <!-- HTML RAW -->
                            <template v-else-if="column.type === 'Html'">
                                <span v-if="row[column.value]" v-html="row[column.value]"></span>
                            </template>
                            <!-- DEFAULT -->
                            <template v-else>
                                {{ row[column.value] }}
                            </template>
                        </template>
                </table-column>

                <table-column cell-class="u-text-nowrap" label="" :sortable="false" :filterable="false">
                    <template slot-scope="row">
                        <div class="o-spacing-tiny">
                            <button v-if="btnCopy" type="button" class="c-button c-button--icon c-button--tiny c-button--neutral" @click="copyPreOrderSheet(row.Id)">
                                <svgicon name="added" width="1em" height="1em"></svgicon>
                                <span>{{ $t('global.copy') }}</span>
                            </button>
                            <button v-if="btnResend" type="button" class="c-button c-button--icon c-button--tiny c-button--neutral" :class="`${row.Type == 'Re-order' ? 'c-button--re-order':''}`" @click="resendToAX(row.Id)">
                                <span>Opnieuw verzenden</span>
                            </button>
                            <button v-if="btnResendPreOrder" type="button" class="c-button c-button--icon c-button--tiny c-button--neutral" @click="resendPreOrderToAX(row.Id)">
                                <span>Opnieuw verzenden</span>
                            </button>
                            <button v-if="btnExport" type="button" class="c-button c-button--icon c-button--tiny c-button--neutral" :class="`${row.Type == 'Re-order' ? 'c-button--re-order':''}`" @click="exportToCSV(row.Id)">
                                <span>Export</span>
                            </button>
                            <button v-if="btnExportPreOrder" type="button" class="c-button c-button--icon c-button--tiny c-button--neutral" @click="exportPreOrderToCSV(row.Id)">
                                <span>Export</span>
                            </button>
                            <button v-if="btnIgnore" type="button" class="c-button c-button--icon c-button--tiny c-button--neutral" @click="ignoreAXWarning(row.Id)">
                                <span>Negeren</span>
                            </button>
                            <router-link v-if="btnViewPath"
                                         class="e-link e-link--no-underline"
                                         :to="{ name: btnViewPath, params: { id: row.Id }}">
                                {{ $t('global.details') }}
                            </router-link>
                            <router-link v-if="btnAssignPath"
                                         class="e-link e-link--no-underline"
                                         :to="{ name: btnAssignPath, params: { id: row.Id, customerKey: row.CustomerKey }}">
                                {{ $t('global.assign') }}
                            </router-link>
                        </div>
                    </template>
                </table-column>

            </table-component>
            <div v-if="rowSelectable" class="select-all">
              <input name="row-selected" type="checkbox" id="select-all" v-model="allSelected" />
              <label v-if="allSelected" for="select-all">{{$t('global.remove_selection')}}</label>
              <label v-else for="select-all">{{$t('global.select_all')}}</label>
            </div>
        </div>
        <slot name="placeholderButtonsFooter"></slot>
    </div>
</div>
</template>

<script>
    import VFilters from '@/components/form/filters/Filters'
    import VSelect from '@/components/form/Select'
    import VPagination from '@/components/Pagination'
    import VLoading from '@/components/Loading'
    import VInput from '@/components/form/Input'
    import _isEmpty from 'lodash/isEmpty'

    export default {
        components: {
            VFilters,
            VSelect,
            VPagination,
            VLoading,
            VInput
        },
        props: {
            dataTable: String, // Vuex getter for table data
            dataFilter: String, // Vuex getter for filter data options
            dataPagination: String, // Vuex getter for pagination data options
            prefix: String, // Use something unique like a1_
            pageSize: Number,
            filters: { type: [Array, Boolean] },
            tableColumns: Array,
            btnCopy: Boolean,
            btnResend: Boolean,
            btnResendPreOrder: Boolean,
            btnExport: Boolean,
            btnExportPreOrder: Boolean,
            btnIgnore: Boolean,
            btnViewPath: String,
            btnAssignPath: String,
            title: String,
            filterTheme: String,
            wrapper: { type: Boolean, default: true },
            rowSelectable: { type: Boolean, default: false },
            searchFilter: {type: Boolean, default: false}
        },
        data() {
            return {
                table: {
                    columns: [],
                    rows: [],
                    options: {
                        search: false,
                        paging: true,
                    }
                },
                paginationConfig: {
                    Page: 1
                },
                selectedFilters: {},
                rowSelected: [],
                allSelected: false,
                loaded: {},
                search: '',
            }
        },
        created() {
            if (this.dataFilter) {
                this.filters.forEach((filter) => {
                    this.$set(this.selectedFilters, [filter.value], null);
                })

                if (this.$route.query[this.prefix + 'search']) {
                    this.search = this.$route.query[this.prefix + 'search'];
                }
            }
            this.initialDataFetch();
        },
        watch: {
            allSelected(value) {
              this.rowSelected = value ? this.TableData.map(a => a.Id) : [];
              this.$emit('selectedRows', this.rowSelected)
            }
        },
        computed: {
            TableData() {
                return this.$store.getters[this.dataTable]
            },
            FilterData() {
                if (!this.dataFilter) { return }
                let output = {};
                let data = this.$store.getters[this.dataFilter];

                // Only get filters from props
                if (data) {
                    this.filters.forEach((filter) => {
                        this.$set(output, [filter.single], data[filter.single]);
                    });
                }

                return _isEmpty(data) ? null : output;
            },
            Pagination() {
                return this.$store.getters[this.dataPagination]
            },
            urlFilters() {
                if (!this.dataFilter) { return }
                let params = {};

                params.Page = this.paginationConfig.Page;
                params.PageSize = this.pageSize;
                params.search = this.search;

                this.filters.forEach((filter) => {
                    params[filter.value] = this.createUrlParams(filter.value.toString());
                })

                return params;
            },
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: {
            // Initial fetch
            initialDataFetch() {
                let query = {};
                if (this.prefix && Object.keys(this.$route.query).includes(this.prefix+'Page')) {
                    Object.keys(this.$route.query).forEach((key) => {
                        this.$set(query, [key.replace(this.prefix, '')], this.$route.query[key]);
                    });
                } else {
                    query = this.$route.query;
                }

                this.dispatchTableData(query);
            },
            // All fetching after initial fetch
            fetchData() {
                this.loaded = {};
                let params = this.urlFilters;
                this.dispatchTableData({
                    Page: this.paginationConfig.Page,
                    PageSize: this.pageSize,
                    ...params
                });
            },
            dispatchTableData(params) {
                this.$store.dispatch(('get'+this.dataTable).toString(), {
                    params: {
                        PageSize: this.pageSize,
                        ...params
                    }
                }).then(() => {
                    if (typeof this.TableData !== "undefined" && typeof this.table.rows !== "undefined") {
                        this.table.rows = this.TableData;
                    }
                    if (this.dataPagination || this.dataFilter){
                        this.setRouterParams(params);
                    }
                    if (this.dataFilter) {
                        this.syncSelectedFilters();
                    }
                    this.loaded = {isLoaded: true};
                    this.$emit('dataLoaded', this.TableData);
                }).catch(() => {
                    this.loaded = {isLoaded: true};
                });
            },
            syncSelectedFilters() {
                this.filters.forEach((filter) => {
                    this.selectedFilters[filter.value] = this.filterSelectedItems(filter.single);
                })
            },
            filterSelectedItems(name) {
                return this.FilterData[name].filter((filter) => {
                    return filter.IsSelected;
                })
            },
            // Push params to browser address bar
            setRouterParams(params) {
                let query = {};
                let urlQuery = this.$route.query;

                // Return on empty params
                if (Object.keys(params).length === 0 && params.constructor === Object) { return; }

                // Check for prefix and when there is no prefix in query
                if (this.prefix) {
                    Object.keys(params).forEach((key) => {
                        // Don't use prefix if prefix exists
                        if (Object.keys(urlQuery).includes((key))) {
                            this.$set(query, key, params[key]);
                        }
                        // Use prefix for new values
                        else {
                            this.$set(query, (this.prefix+key), params[key]);
                        }
                    });
                } else {
                    query = params;
                }

                // Merge values
                query = Object.assign({}, urlQuery, query);

                // Push to router
                this.$router.push({
                    path: this.$route.path,
                    query: { ...query }
                });
            },
            // Convert object to comma separated values for ajax call
            createUrlParams(name) {
                if (this.selectedFilters[name] && this.selectedFilters[name].length) {
                    return this.selectedFilters[name].map(item => {
                        return item.Value
                    }).join();
                } else {
                    return undefined;
                }
            },
            copyPreOrderSheet(id) {
                this.$store.dispatch('copyPreOrderSheet', id).then((newId) => {
                    if (newId) {
                        this.$router.push({
                            name: 'AdminPreOrdersEdit',
                            params: {id: newId}
                        });
                    }

                    // Show notification
                    this.$notify({
                        group: 'global',
                        title: 'Gedupliceerd.',
                        text: 'De pre order fiche is successvol gedupliceerd.',
                        type: 'success',
                        duration: 3000
                    });
                });
            },
            ignoreAXWarning(id) {
                this.$store.dispatch('ignoreAXWarning', id).then(() => {
                    this.fetchData();

                    // Show notification
                    this.$notify({
                        group: 'global',
                        title: 'Genegeerd.',
                        text: 'De waarschuwing is genegeerd.',
                        type: 'success',
                        duration: 3000
                    });
                })
            },
            exportToCSV(id) {
                this.$store.dispatch('exportToCSV', id).then((csv) => {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display:none";

                    const blob = new Blob([csv], {type: "text/csv"});

                    // IE10+ : (has Blob, but not a[download] or URL)
                    if (navigator.msSaveBlob) {
                        return navigator.msSaveBlob(blob, "export.csv");
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = "export.csv";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }
                });
            },
            exportPreOrderToCSV(id) {
                this.$store.dispatch('exportPreOrderToCSV', id).then((csv) => {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display:none";

                    const blob = new Blob([csv], {type: "text/csv"});

                    // IE10+ : (has Blob, but not a[download] or URL)
                    if (navigator.msSaveBlob) {
                        return navigator.msSaveBlob(blob, "export.csv");
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = "export.csv";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }
                });
            },
            resendToAX(id) {
                this.$store.dispatch('resendToAX', id).then(() => {
                    this.fetchData();

                    // Show notification
                    this.$notify({
                        group: 'global',
                        title: 'Opnieuw verzonden.',
                        text: 'De order is opnieuw naar AX verzonden voor verwerking.',
                        type: 'success',
                        duration: 3000
                    });
                });
            },
            resendPreOrderToAX(id) {
                this.$store.dispatch('resendPreOrderToAX', id).then(() => {
                    this.fetchData();

                    // Show notification
                    this.$notify({
                        group: 'global',
                        title: 'Opnieuw verzonden.',
                        text: 'De order is opnieuw naar AX verzonden voor verwerking.',
                        type: 'success',
                        duration: 3000
                    });
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
  .select-all {
    margin-left: 1em;
    input {
      position: relative;
      top: -2px;
      cursor: pointer;
    }
    label {
      cursor: pointer;
      padding-left: 0.5em;
    }
  }
  .c-button--re-order {
      visibility:hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/OverviewList.vue